/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{color:#fff;text-decoration:none}.spacer[_ngcontent-%COMP%]{flex:1 1 auto}.right-links[_ngcontent-%COMP%]{padding-left:20px}.nav-links[_ngcontent-%COMP%]{display:none}.nav-links-menu[_ngcontent-%COMP%]{display:inline-block}@media (min-width:600px){.nav-links[_ngcontent-%COMP%]{display:inline-block}.nav-links-menu[_ngcontent-%COMP%]{display:none}}"];
export { styles as styles };
